<template>
  <v-row no-gutters class="flex-column">
    <v-row no-gutters>
      <v-radio-group
        v-model="radioModel"
        hide-details="auto"
        class="flex-grow-1"
        :disabled="disabled"
      >
        <v-radio
          v-for="(option, index) in allOptions"
          :key="index"
          class="extraction-field-single-choice-option"
          :label="option"
          :value="option"
        >
          <template #label>
            <span
              class="grey--text text--darken-2 text-body-2 font-weight-light"
            >
              {{ option }}
            </span>
          </template>
        </v-radio>
      </v-radio-group>
    </v-row>
    <v-row no-gutters>
      <v-text-field
        v-if="allowOther"
        v-model="otherModel"
        hide-details="auto"
        single-line
        :placeholder="label"
        class="flex-grow-1 text-body-2"
        :disabled="disableOtherField"
      />
    </v-row>
  </v-row>
</template>

<script>
import { typeHelpers } from '@/modules';

export default {
  name: 'ExtractionFieldSingleSelect',
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      required: true,
      validator: (val) => typeHelpers.isArrayOfType(val, 'string'),
    },
    allowOther: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  data: () => ({
    otherSelected: false,
  }),
  computed: {
    radioModel: {
      get: function () {
        return this.otherSelected ? 'Other' : this.value;
      },
      set: function (value) {
        if (value === 'Other') {
          this.otherSelected = true;
          this.$emit('input', '');
        } else {
          this.otherSelected = false;
          this.$emit('input', value);
        }
      },
    },
    otherModel: {
      get: function () {
        if (this.options.includes(this.value)) {
          return '';
        }
        return this.otherSelected ? this.value : '';
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    allOptions() {
      return this.options.concat(this.allowOther ? ['Other'] : []);
    },
    disableOtherField() {
      return !this.otherSelected || this.disabled;
    },
  },
  created() {
    this.checkIfValueIsOther(this.value);
  },
  methods: {
    checkIfValueIsOther(value) {
      this.otherSelected =
        this.allowOther &&
        !this.options.includes(value) &&
        value !== null;
    },
  },
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';
.v-radio.extraction-field-single-choice-option
  .v-input--selection-controls__input
  .v-icon {
  color: map-get($grey, 'darken-2') !important;
  caret-color: map-get($grey, 'darken-2') !important;
}
</style>
